// extracted by mini-css-extract-plugin
export var ImgSection = "imgSection-module--ImgSection--8c8bc";
export var ImgSection___heading = "imgSection-module--ImgSection___heading--b50d8";
export var ImgSection___spacingBottom = "imgSection-module--ImgSection___spacingBottom--d9f0c";
export var ImgSection___spacingInline = "imgSection-module--ImgSection___spacingInline--50b14";
export var ImgSection___spacingLeft = "imgSection-module--ImgSection___spacingLeft--0c2c1";
export var ImgSection___spacingTop = "imgSection-module--ImgSection___spacingTop--1144f";
export var ImgSection_img = "imgSection-module--ImgSection_img--60c0e";
export var slideIn = "imgSection-module--slide-in--7e6c2";
export var slideInFromRight = "imgSection-module--slide-in-from-right--5947f";